import React, { useState, useMemo } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Select,
  Container,
  IconButton,
  useMediaQuery,
  Paper,
  Collapse,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  Avatar,
  ListItemText,
  Checkbox,
} from "@mui/material";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import Menu from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import Navigation from "../../../components/Navigation";
import { convertTimeToDate } from "../../../services/helper";
import routes from "../../../routes";
import MenuComponent from "../../../components/MenuComponent";
import ConfirmModal from "../../../components/ConfirmModal";
import {
  holidayRequestFields,
  overTimeRequestFields,
} from "../../../services/helper";
const MyHolidays = () => {
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [createHolidayExpanded, setCreateHolidayExpanded] = useState(false);
  const [submittedExpanded, setSubmittedExpanded] = useState(false);
  const [overtimeExpanded, setOvertimeExpanded] = useState(false);
  const [insightsExpanded, setInsightsExpanded] = useState(false);
  const [selectedOption, setSelectedOption] = useState("holiday");
  const [submittedReportsTab, setSubmittedReportsTab] = useState("taken");
  const [submittedOvertimeTab, setSubmittedOvertimeTab] = useState("taken");
  const [insightsTab, setInsightsTab] = useState("allreq");
  const [confirmModal, setConfirmModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [editData, setEditData] = useState({});

  const holidays_all = JSON.parse(localStorage.getItem("holiday")) || [];
  const overtime_all = JSON.parse(localStorage.getItem("overtime")) || [];

  const queries_holiday = holidays_all.filter(
    (item) => item.status === "Queried" && !item.isDraft,
  );
  const queries_overtime = overtime_all.filter(
    (item) => item.status === "Queried" && !item.isDraft,
  );
  const pendings = holidays_all.filter(
    (item) => item.status === "Pending" && !item.isDraft,
  );

  const holidays = holidays_all.filter(
    (item) => item.type === "holiday" && !item.isDraft,
  );
  const overtimes = overtime_all.filter(
    (item) => item.type === "overtime" && !item.isDraft,
  );

  const holidays_approved = holidays.filter(
    (item) => item.status === "Approved",
  );

  const holidays_pendings = holidays.filter(
    (item) => item.status === "Pending",
  );

  const holidays_taken = holidays.filter(
    (item) =>
      item.status === "Approved" && new Date() > new Date(item.dateRange[1]),
  );

  const holidays_drafts = holidays_all.filter(
    (item) => item.type === "holiday" && item.isDraft,
  );

  const overtimes_approved = overtimes.filter(
    (item) => item.status === "Approved",
  );

  const overtimes_pendings = overtimes.filter(
    (item) => item.status === "Pending",
  );

  const overtimes_taken = overtimes.filter(
    (item) =>
      item.status === "Approved" &&
      new Date() > new Date(item.dateOfObservation),
  );
  const overtimes_drafts = overtime_all.filter(
    (item) => item.type === "overtime" && item.isDraft,
  );

  const handleFilterToggle = () => {
    setShowFilters((prev) => !prev); // Toggle the visibility of filters
  };

  const handleSubmittedReportsTabChange = (event, newValue) => {
    setSubmittedReportsTab(newValue);
  };
  const handleSubmittedOvertimeTabChange = (event, newValue) => {
    setSubmittedOvertimeTab(newValue);
  };
  const handleInsightsReportsTabChange = (event, newValue) => {
    setInsightsTab(newValue);
  };
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleCreateHoliday = () => {
    navigate(routes.myHolidaysCreate.path, {
      state: { reportType: selectedOption, status: selectedOption },
    });
  };

  const [drawerOpen, setDrawerOpen] = useState(false); // State to manage Drawer open/close

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen); // Toggle Drawer visibility
  };

  const handleItemEdit = (report, fromInsight) => {
    setConfirmModal(true);
    setEditData((prev) => ({
      ...prev,
      ...report,
      fromInsight: fromInsight,
    }));
  };

  const handleEdit = (field, value) => {
    console.log("Editing field value:", field, value);

    if (field === "attachedFile") {
      value = value.name;
    }
    if (value !== undefined) {
      navigate(routes.myHolidaysCreate.path, {
        state: {
          holidayData: editData,
          status: editData.type,
          fromInsight: editData.fromInsight,
          highlighted: field,
        },
      });
    } else {
      navigate(routes.myHolidaysCreate.path, {
        state: {
          holidayData: editData,
          status: editData.type,
          fromInsight: editData.fromInsight,
        },
      });
    }
  };

  const handleCancel = () => {};

  const handleToggleCreateHoliday = () =>
    setCreateHolidayExpanded(!createHolidayExpanded);
  const handleToggleOvertime = () => setOvertimeExpanded(!overtimeExpanded);
  const handleToggleSubmitted = () => setSubmittedExpanded(!submittedExpanded);
  const handletoggleInsights = () => setInsightsExpanded(!insightsExpanded);

  const filteredInsights = useMemo(() => {
    const insightData =
      insightsTab === "allreq"
        ? [...holidays, ...overtimes]
        : insightsTab === "Queried"
          ? [...queries_holiday, ...queries_overtime]
          : [...pendings, ...overtimes_pendings];
    return insightData.filter((insight) => {
      const statusMatch =
        statusFilter.length > 0 ? statusFilter.includes(insight.status) : true;

      const [start, end] =
        insight.type === "holiday"
          ? insight.dateRange
          : [insight.dateOfObservation, insight.dateOfObservation];

      const dateMatch =
        (!startDate || new Date(start) >= new Date(startDate)) &&
        (!endDate || new Date(end) <= new Date(endDate));

      return statusMatch && dateMatch;
    });
  }, [
    statusFilter,
    startDate,
    endDate,
    holidays,
    insightsTab,
    overtimes,
    queries_holiday,
    queries_overtime,
    pendings,
    overtimes_pendings,
  ]);
  const submitted =
    submittedReportsTab === "taken"
      ? holidays_taken
      : submittedReportsTab === "Approved"
        ? holidays_approved
        : submittedReportsTab === "Pending"
          ? holidays_pendings
          : holidays_drafts;
  const overTimeData =
    submittedOvertimeTab === "taken"
      ? overtimes_taken
      : submittedOvertimeTab === "Approved"
        ? overtimes_approved
        : submittedOvertimeTab === "Pending"
          ? overtimes_pendings
          : overtimes_drafts;
  const handleMyHolidayTaken = () => {
    setSubmittedExpanded(!submittedExpanded);
    setSubmittedReportsTab("taken");
  };
  const handleMyHolidayApproved = () => {
    setSubmittedExpanded(!submittedExpanded);
    setSubmittedReportsTab("Approved");
  };
  const handleMyHolidayPending = () => {
    setSubmittedExpanded(!submittedExpanded);
    setSubmittedReportsTab("Pending");
  };
  const handleMyHolidayDrafts = () => {
    setSubmittedExpanded(!submittedExpanded);
    setSubmittedReportsTab("Draft");
  };

  const handleOverTimeTaken = () => {
    setOvertimeExpanded(!overtimeExpanded);
    setSubmittedOvertimeTab("taken");
  };
  const handleOverTimeApproved = () => {
    setOvertimeExpanded(!overtimeExpanded);
    setSubmittedOvertimeTab("Approved");
  };
  const handleOverTimePending = () => {
    setOvertimeExpanded(!overtimeExpanded);
    setSubmittedOvertimeTab("Pending");
  };
  const handleOverTimeDrafts = () => {
    setOvertimeExpanded(!overtimeExpanded);
    setSubmittedOvertimeTab("Draft");
  };

  const handleInsightsAllRequests = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("allreq");
  };
  const handleInsightsQueried = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("Queried");
  };
  const handleInsightsPending = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("Pending");
  };

  // const handleAnalytics = () => {
  //   const analyticsData = {
  //     pending:
  //       holidays_all.filter((item) => item.status === "Pending").length +
  //       overtime_all.filter((item) => item.status === "Pending").length,
  //     escalated:
  //       holidays_all.filter((item) => item.status === "Approved").length +
  //       overtime_all.filter((item) => item.status === "Approved").length,
  //     noActionReq:
  //       holidays_all.filter((item) => item.status === "Rejected").length +
  //       overtime_all.filter((item) => item.status === "Rejected").length,
  //     queried:
  //       holidays_all.filter((item) => item.status === "Queried").length +
  //       overtime_all.filter((item) => item.status === "Queried").length,
  //     draft:
  //       holidays_all.filter((item) => item.isDraft === true).length +
  //       overtime_all.filter((item) => item.isDraft === true).length,
  //   };
  //   setAnalyticsData(analyticsData);
  //   setOpenAnalyticsModal(true);
  // };
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ecf0f7",
      }}
    >
      <Box
        sx={{
          height: "129px",
          backgroundColor: "#1C1468",
          color: "white",
          display: "flex",
          alignItems: "center",
          marginLeft: "-24px",
          marginRight: "-24px",
          zIndex: 3,
          justifyContent: "space-between",
          position: "fixed",
          width: isNonMobile ? "444px" : "calc(100vw + 10px)",
        }}
      >
        <IconButton
          edge="start"
          sx={{ marginLeft: "10px" }}
          color="inherit"
          onClick={() => navigate(routes.home.path)}
        >
          <ChevronLeftOutlined />
        </IconButton>

        <Typography sx={{ fontSize: "16px" }} variant="h5" fontWeight="bold">
          Holidays - Overtime
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          sx={{ marginRight: "15px" }}
          onClick={handleDrawerToggle}
        >
          <Menu />
        </IconButton>
        <MenuComponent
          open={drawerOpen} // Drawer visibility
          onClose={handleDrawerToggle} // Handler to close the drawer
        />
      </Box>

      <Paper
        sx={{
          backgroundColor: "#fff",
          padding: 3,
          marginTop: "159px",
          cursor: "pointer",
        }}
        onClick={() => handleToggleCreateHoliday(!createHolidayExpanded)}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center" }}
        >
          Create New Request
          <IconButton
            onClick={() => handleToggleCreateHoliday(!createHolidayExpanded)}
            sx={{ marginLeft: "auto" }}
          >
            {createHolidayExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Typography>
        <Collapse
          in={createHolidayExpanded}
          onClick={(e) => e.stopPropagation()}
        >
          <RadioGroup value={selectedOption} onChange={handleChange}>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12}>
                <FormControlLabel
                  value="holiday"
                  control={<Radio />}
                  label="Holiday"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  value="overtime"
                  control={<Radio />}
                  label="Overtime"
                />
              </Grid>
            </Grid>
          </RadioGroup>
          <Button
            onClick={handleCreateHoliday}
            variant="outlined"
            fullWidth
            sx={{
              marginTop: "30px",
              color: "#2d3648",
              border: "2px solid #2d3648",
              textTransform: "capitalize",
              fontWeight: "700",
              height: "60px",
              padding: "0 20px",
            }}
          >
            Create Request &gt;
          </Button>
        </Collapse>
      </Paper>

      <Box sx={{ height: "20px" }} />

      {/* Submitted Section */}
      <Paper
        sx={{ backgroundColor: "#fff", padding: 3, cursor: "pointer" }}
        onClick={() => handleToggleSubmitted(!submittedExpanded)}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          My Holidays
          <span
            style={{
              fontSize: "0.9rem",
              fontWeight: "normal",
              marginLeft: "6px",
            }}
          >
            • {28 - holidays_taken.length} out of 28 Days Left
          </span>
          <IconButton
            onClick={() => handleToggleSubmitted(!submittedExpanded)}
            sx={{ marginLeft: "auto" }}
          >
            {submittedExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Typography>
        <Collapse in={!submittedExpanded} onClick={(e) => e.stopPropagation()}>
          <Box>
            <Typography
              variant="body1"
              sx={{ display: "flex", gap: 2, color: "#333", fontWeight: 400 }}
            >
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleMyHolidayTaken();
                }}
              >
                Taken:{" "}
                <strong style={{ color: "#0056b3" }}>
                  {holidays_taken.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleMyHolidayApproved();
                }}
              >
                Approved:{" "}
                <strong style={{ color: "#28a745" }}>
                  {holidays_approved.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleMyHolidayPending();
                }}
              >
                Pending:{" "}
                <strong style={{ color: "#ffc107" }}>
                  {holidays_pendings.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleMyHolidayDrafts();
                }}
              >
                Draft:{" "}
                <strong style={{ color: "#ffc107" }}>
                  {holidays_drafts.length}
                </strong>
              </span>
            </Typography>
          </Box>
        </Collapse>
        <Collapse in={submittedExpanded}>
          <Tabs
            value={submittedReportsTab}
            onChange={(e, newValue) => {
              e.stopPropagation(); // Prevents the parent click event
              handleSubmittedReportsTabChange(e, newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="false"
            sx={{
              marginBottom: "30px",
              "& .MuiTab-root": {
                padding: "6px 12px", // Adjust padding as needed
                minWidth: 0, // Remove default minimum width if necessary
              },
              "& .MuiTab-wrapper": {
                alignItems: "center", // Keep the content centered
              },
            }}
          >
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Taken
                  <br />
                  {holidays_taken.length}
                </span>
              }
              value="taken"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Approved
                  <br />
                  {holidays_approved.length}
                </span>
              }
              value="Approved"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Pending
                  <br />
                  {holidays_pendings.length}
                </span>
              }
              value="Pending"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Drafts
                  <br />
                  {holidays_drafts.length}
                </span>
              }
              value="Draft"
            />
          </Tabs>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ background: "#ccc" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "700" }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>Start Date</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>End Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {submitted.map((report, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleItemEdit(report, false)}
                  >
                    <TableCell>{report.type}</TableCell>
                    <TableCell>
                      {convertTimeToDate(report.dateRange[0])}
                    </TableCell>
                    <TableCell>
                      {convertTimeToDate(report.dateRange[1])}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </Paper>

      <Box sx={{ height: "20px" }} />
      <Paper
        sx={{ backgroundColor: "#fff", padding: 3, cursor: "pointer" }}
        onClick={() => handleToggleOvertime(!overtimeExpanded)}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center" }}
        >
          My Overtime
          <IconButton
            onClick={() => handleToggleOvertime(!overtimeExpanded)}
            sx={{ marginLeft: "auto" }}
          >
            {overtimeExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Typography>
        <Collapse in={!overtimeExpanded}>
          <Box onClick={(e) => e.stopPropagation()}>
            <Typography
              variant="body1"
              sx={{ display: "flex", gap: 2, color: "#333", fontWeight: 400 }}
            >
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleOverTimeTaken();
                }}
              >
                Taken:{" "}
                <strong style={{ color: "#0056b3" }}>
                  {overtimes_taken.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleOverTimeApproved();
                }}
              >
                Approved:{" "}
                <strong style={{ color: "#28a745" }}>
                  {overtimes_approved.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleOverTimePending();
                }}
              >
                Pending:{" "}
                <strong style={{ color: "#ffc107" }}>
                  {overtimes_pendings.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleOverTimeDrafts();
                }}
              >
                Drafts:{" "}
                <strong style={{ color: "#ffc107" }}>
                  {overtimes_drafts.length}
                </strong>
              </span>
            </Typography>
          </Box>
        </Collapse>
        <Collapse in={overtimeExpanded}>
          <Tabs
            value={submittedOvertimeTab}
            onChange={(e, newValue) => {
              e.stopPropagation(); // Prevents the parent click event
              handleSubmittedOvertimeTabChange(e, newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="false"
            sx={{
              marginBottom: "30px",
              "& .MuiTab-root": {
                padding: "6px 12px", // Adjust padding as needed
                minWidth: 0, // Remove default minimum width if necessary
              },
              "& .MuiTab-wrapper": {
                alignItems: "center", // Keep the content centered
              },
            }}
          >
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Taken
                  <br />
                  {overtimes_taken.length}
                </span>
              }
              value="taken"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Approved
                  <br />
                  {overtimes_approved.length}
                </span>
              }
              value="Approved"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Pending
                  <br />
                  {overtimes_pendings.length}
                </span>
              }
              value="Pending"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Drafts
                  <br />
                  {overtimes_drafts.length}
                </span>
              }
              value="Draft"
            />
          </Tabs>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ background: "#ccc" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "700" }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>Start Date</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>End Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {overTimeData.map((report, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleItemEdit(report, false)}
                  >
                    <TableCell>{report.type}</TableCell>
                    <TableCell>
                      {convertTimeToDate(report.dateOfObservation)}
                    </TableCell>
                    <TableCell>
                      {convertTimeToDate(report.dateOfObservation)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </Paper>

      <Box sx={{ height: "20px" }} />

      {/* Insights Section */}
      <Paper
        sx={{
          backgroundColor: "#fff",
          padding: 3,
          marginBottom: "20px",
          cursor: "pointer",
        }}
        onClick={() => handletoggleInsights(!insightsExpanded)}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center" }}
        >
          Insights -
          <span
            style={{
              fontSize: "1rem",
              fontWeight: "normal",
              marginLeft: "4px",
            }}
          >
            Requests Received
          </span>
          <IconButton
            onClick={() => handletoggleInsights(!insightsExpanded)}
            sx={{ marginLeft: "auto" }}
          >
            {insightsExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Typography>
        <Collapse in={!insightsExpanded}>
          <Box>
            <Typography
              variant="body1"
              sx={{ display: "flex", gap: 2, color: "#333", fontWeight: 400 }}
            >
              <span
                style={{ color: "#777" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleInsightsAllRequests();
                }}
              >
                All Requests:{" "}
                <strong
                  style={{
                    color: "#0056b3",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {holidays.length + overtimes.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleInsightsQueried();
                }}
              >
                Queried:{" "}
                <strong style={{ color: "#28a745" }}>
                  {queries_holiday.length + queries_overtime.length}
                </strong>
              </span>
              <span
                style={{
                  color: "#777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleInsightsPending();
                }}
              >
                Pending:{" "}
                <strong style={{ color: "#ffc107" }}>
                  {holidays_pendings.length + overtimes_pendings.length}
                </strong>
              </span>
            </Typography>
          </Box>
        </Collapse>

        {insightsExpanded && (
          <>
            <Box sx={{ textAlign: "right", width: "100%", mt: "-9" }}>
              Filter&nbsp;{" "}
              <IconButton
                sx={{
                  border: "1px solid #CAD3E7",
                  borderRadius: "4px",
                  backgroundColor: "#f3f6f9",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleFilterToggle();
                }}
                aria-label="toggle filters"
              >
                {/* Use your custom filter icon here */}
                <img
                  sx={{ display: "block", float: "right" }}
                  src="/images/icons/filter-icon.svg"
                  alt="Filter Icon"
                  width="16"
                  height="16"
                />
              </IconButton>
            </Box>
            <br />
          </>
        )}
        <Collapse in={insightsExpanded}>
          {showFilters && (
            <Box
              sx={{ display: "flex", gap: 2, mb: 2 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Select
                multiple
                value={statusFilter}
                onChange={(e) => {
                  e.stopPropagation(); // Prevents parent click event
                  setStatusFilter(e.target.value);
                }}
                displayEmpty
                fullWidth
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return `All Statuses (${holidays.length + overtimes.length})`; // Placeholder when nothing is selected
                  }
                  return selected.join(", "); // Display selected options as a comma-separated string
                }}
                sx={{ minWidth: 120 }}
              >
                <MenuItem value="Approved">
                  <ListItemText
                    primary={`Approved (${holidays_approved.length + overtimes_approved.length})`}
                  />
                  <Checkbox checked={statusFilter.includes("Approved")} />
                </MenuItem>

                <MenuItem value="Queried">
                  <ListItemText
                    primary={`Queried (${queries_holiday.length + queries_overtime.length})`}
                  />
                  <Checkbox checked={statusFilter.includes("Queried")} />
                </MenuItem>
                <MenuItem value="Pending">
                  <ListItemText
                    primary={`Pending (${holidays_pendings.length + overtimes_pendings.length})`}
                  />
                  <Checkbox checked={statusFilter.includes("Pending")} />
                </MenuItem>
              </Select>

              <TextField
                label="Start Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={startDate}
                onChange={(e) => {
                  e.stopPropagation(); // Prevents parent click event
                  setStartDate(e.target.value);
                }}
              />

              <TextField
                label="End Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={endDate}
                onChange={(e) => {
                  e.stopPropagation(); // Prevents parent click event
                  setEndDate(e.target.value);
                }}
              />
            </Box>
          )}
          <Tabs
            value={insightsTab}
            onChange={(e, newValue) => {
              e.stopPropagation(); // Prevents the parent click event
              handleInsightsReportsTabChange(e, newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="false"
            sx={{
              marginBottom: "30px",
              "& .MuiTab-root": {
                padding: "6px 12px", // Adjust padding as needed
                minWidth: 0, // Remove default minimum width if necessary
              },
              "& .MuiTab-wrapper": {
                alignItems: "center", // Keep the content centered
              },
            }}
          >
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  All Requests
                  <br />
                  {holidays.length + overtimes.length}
                </span>
              }
              style={{ padding: "9px 12px" }}
              value="allreq"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Queried
                  <br />
                  {queries_holiday.length + queries_overtime.length}
                </span>
              }
              style={{ padding: "9px 12px" }}
              value="Queried"
            />
            <Tab
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  Pending
                  <br />
                  {holidays_pendings.length + overtimes_pendings.length}
                </span>
              }
              style={{ padding: "9px 12px" }}
              value="Pending"
            />
          </Tabs>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ background: "#ccc" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "700" }}>User</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>Start Date</TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                    }}
                  >
                    End Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "700" }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredInsights.map((report, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleItemEdit(report, true)}
                  >
                    <TableCell>
                      <Avatar
                        alt="User Photo"
                        src={report.photoUrl || "path/to/default/photo.jpg"}
                        sx={{ width: 30, height: 30, marginRight: 2 }}
                      />
                      John Smith
                    </TableCell>
                    <TableCell>{report.type}</TableCell>
                    <TableCell>
                      {convertTimeToDate(
                        report.type === "holiday"
                          ? report.dateRange[0]
                          : report.dateOfObservation,
                      )}
                    </TableCell>
                    <TableCell>
                      {convertTimeToDate(
                        report.type === "holiday"
                          ? report.dateRange[1]
                          : report.dateOfObservation,
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color={`${report.status === "Pending" ? "warning" : report.status === "Approved" ? "success" : "error"}`}
                      >
                        {report.status}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </Paper>

      <ConfirmModal
        open={confirmModal}
        onClose={(field, value) => {
          setConfirmModal(false);
          if (field && typeof field !== "object" && value !== "backdropClick") {
            handleEdit(field, value);
          } else {
            handleCancel();
          }
        }}
        title={
          editData.type === "holiday"
            ? "Holiday Request Summary"
            : "Overtime Request Summary"
        }
        fields={
          editData.type === "holiday"
            ? holidayRequestFields
            : overTimeRequestFields
        }
        formData={editData}
        handleEdit={handleEdit}
        preview={true}
      />
      <Box sx={{ height: "20px" }} />
      <Navigation />
    </Container>
  );
};

export default MyHolidays;
